import React, { useEffect, useRef, useState, useImperativeHandle } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import GlobalClassFile from "../popups/GlobalClassFile";
import { createModal } from "../hooks/createModal";
import { kbdEvent } from "../utils/Utils";

const CategorySelectorInput = React.forwardRef((props, ref) => {

    const { controller = "", autoselect = false, route = "", category_2 = "", category_1 = "", doubleclick = false, command = KBD.F4, controlled = false, field = "both", value = "", width = 0, className = "", secondary = false, warning = false, style = {}, right = false, medium, edit = false, placeholder = "", onSelect = () => { }, onChange = () => { }, onFocus = () => { } } = props;

    const inputRef = useRef(null);



    useImperativeHandle(ref, () => ({
        blur: () => {
            if (inputRef.current) {
                inputRef.current.blur();
            }
        },
        element: inputRef.current,
        focus: () => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        },
        // You can expose other methods or properties here if needed
    }));

    const [focused, setFocused] = useState(false)

    const onInputFocus = (e) => {
        if (autoselect) {
            e.target.select();
        }
        setFocused(true);
        onFocus();
    }
    const onInputBlur = () => {
        setFocused(false);
    }

    // Handle double click event
    const handleDoubleClick = () => {
        kbdEvent(doubleclick);
    };

    const drawClassFile = () => {
        inputRef.current.blur();
        window.bm_state.value = ROUTES.HELPERS.CLASS_SELECTOR;
        createModal({
            component: <GlobalClassFile controller={controller} category_1={category_1} category_2={category_2} route={ROUTES.HELPERS.CLASS_SELECTOR} />, closable: true, title: "Classification File", callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    const { category_1 = "", category_2 = "" } = e;
                    switch (field) {
                        case "both":
                            inputRef.current.value = (category_2 && category_1) ? category_1 + " - " + category_2 : category_1;
                            break;
                        case "one":
                            inputRef.current.value = category_1;
                            break;
                        case "two":
                            inputRef.current.value = category_2;
                            break;
                    }
                    onChange(inputRef.current.value, category_1, category_2);
                    setTimeout(() => {
                        onSelect(inputRef.current.value, category_1, category_2);
                    }, 50)

                }
                inputRef.current.focus();
            }
        })
    }


    useEffect(() => {

        if (focused) {
            const actions = [
                { key: KBD.ESCAPE, action: () => { } },
                { key: command, action: () => { drawClassFile() } }
            ];
            const cleanup = listen(controller, route, actions, false, [command], [command]);
            return cleanup;
        }


    }, [focused, category_1, category_2])


    let _class = (edit) ? "ui-input edit" : "ui-input";
    if (secondary) { _class += " secondary"; }
    if (warning) { _class += " warning"; }
    if (className) { _class += " " + className; }
    if (right) { _class += " ra"; }
    if (width) { style.width = width + "px"; }
    if (medium) { _class += " medium"; }

    if (edit) {
        return (<input maxLength={8} onDoubleClick={doubleclick ? handleDoubleClick : undefined} onChange={(e) => onChange(e.target.value)} onBlur={() => onInputBlur()} onFocus={(e) => onInputFocus(e)} ref={inputRef} placeholder={placeholder} style={{ ...style }}  {...(controlled ? { value } : { defaultValue: value })} className={_class} />)
    }
    return (<div style={{ ...style }} className={_class}>{value}</div>)
});

export default CategorySelectorInput;